import * as Api from '@ViewModels';
import { CampaignType, ISystemEmailTemplateWithStatuses } from '../../../../../models/AdminModels';
import { useEventLogging } from '../../../../../models/Logging';
import { useErrorMessages } from '../../../../../models/hooks/appStateHooks';
import {
	useAdminBlogTemplateAddStatusesMutation,
	useAdminTemplateIndustryCategoriesStatusesMutation,
	useAdminTemplateIndustrySocialCategoriesStatusesMutation,
} from '../../../../../queries';
import { DropdownItem } from '../../../../../web/components-v2/Dropdown';

interface Props {
	industry: Api.Industry;
	templateId: string;
	campaignType: CampaignType;
	onSuccess?: (value: ISystemEmailTemplateWithStatuses) => void;
}

export function TemplateCategoryFeatureDropdownItem({ campaignType, templateId, onSuccess, industry }: Props) {
	const { logApiError, logEvent } = useEventLogging('TemplateCategoryFeatureMoreMenuItem');
	const errorMessages = useErrorMessages();
	const onMutationError = (error: Api.IOperationResultNoValue) => {
		errorMessages.pushApiError(error);
		logApiError('TemplateCategoryFeatureMoreMenuItem-FeatureTemplate-Error', error);
	};
	const emailStatusMutation = useAdminTemplateIndustryCategoriesStatusesMutation({
		onError: onMutationError,
		onSuccess,
	});
	const socialStatusMutation = useAdminTemplateIndustrySocialCategoriesStatusesMutation({
		onError: onMutationError,
		onSuccess,
	});
	const blogStatusMutation = useAdminBlogTemplateAddStatusesMutation({
		onError: onMutationError,
		onSuccess,
	});
	const handleClick = () => {
		switch (campaignType) {
			case CampaignType.Email:
				emailStatusMutation.mutate({
					templateId,
					statuses: [{ status: Api.TemplateStatus.Published, category: 'Featured', industry }],
				});
				break;
			case CampaignType.Social:
				socialStatusMutation.mutate({
					templateId,
					statuses: [{ status: Api.TemplateStatus.Published, category: 'Featured', industry }],
				});
				break;
			case CampaignType.Blog:
				blogStatusMutation.mutate({
					templateId,
					statuses: [{ status: Api.TemplateStatus.Published, category: 'Featured', industry }],
				});
				break;
			default:
				logEvent('Unknown campaign type');
		}
	};
	return <DropdownItem onClick={handleClick}>Feature</DropdownItem>;
}
